import { render } from "./create.vue?vue&type=template&id=17d3cdf8&scoped=true"
import script from "./create.vue?vue&type=script&lang=js"
export * from "./create.vue?vue&type=script&lang=js"

import "./create.vue?vue&type=style&index=0&id=17d3cdf8&lang=scss&scoped=true"
import "./create.vue?vue&type=style&index=1&id=17d3cdf8&lang=scss"

import exportComponent from "/data/jenkins/workspace/talk-community-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17d3cdf8"]])

export default __exports__